// Catalogue des modules organisé par catégories (présentation inspirée de mentaal.fr).
// Titres complets, sans sigle/acronyme.

export const CATEGORY_BADGES = {
  questionnaire: "Questionnaire",
  couple: "Couple",
  exercice: "Exercice",
  famille: "Jeu familial",
  guide: "Guide pratique",
};

export const BADGE_CLASSES = {
  questionnaire: "bg-[var(--sand)] text-[var(--gold)] border border-[var(--gold-light)]/40",
  couple: "bg-[var(--gold)]/10 text-[var(--gold)] border border-[var(--gold)]/25",
  exercice: "bg-[var(--beige)] text-[var(--ink)] border border-[var(--border)]",
  famille: "bg-[#FFF3D6] text-[#B8781A] border border-[#F2B84B]/50",
  guide: "bg-[#E6EFF7] text-[#3E6E95] border border-[#5B8DB8]/40",
};

export const MODULE_CATEGORIES = [
  {
    id: "questionnaires-individuels",
    title: "Questionnaires individuels",
    badge: "questionnaire",
    intro:
      "Outils d'évaluation cliniques pour mesurer les besoins psychologiques, les stratégies d'adaptation et le fonctionnement cognitif.",
    modules: [
      {
        key: "besoins",
        path: "/besoins",
        title: "Évaluation des besoins psychologiques",
        description:
          "Exploration de vos 10 besoins psychologiques fondamentaux : niveau de satisfaction et importance dans le quotidien.",
      },
      {
        key: "cope-28",
        path: "/cope-28",
        title: "Stratégies de coping",
        description:
          "Évaluation des 14 stratégies d'adaptation au stress face à une situation précise. Disponible en français et en espagnol.",
      },
      {
        key: "idr-50",
        path: "/idr-50",
        title: "Inventaire des drivers relationnels",
        description:
          "50 affirmations pour explorer vos messages intérieurs (Sois parfait, Fais plaisir…) et la pression relationnelle interne.",
      },
      {
        key: "qicm-20",
        path: "/qicm-20",
        title: "Insight cognitif et métacognition",
        description:
          "Observation du rapport à vos propres pensées : auto-réflexivité, certitude cognitive et flexibilité face aux croyances.",
      },
    ],
  },
  {
    id: "couple",
    title: "Couple",
    badge: "couple",
    intro:
      "Exercices et questionnaires croisés pour la thérapie de couple : éclairer les besoins partagés et la réciprocité.",
    modules: [
      {
        key: "besoins-couple",
        path: "/besoins-couple",
        title: "Besoins psychologiques — version couple",
        description:
          "Mesurez la satisfaction de vos besoins et estimez celle de votre partenaire pour identifier accords et angles morts.",
      },
      {
        key: "empathie",
        path: "/empathie",
        title: "Ce que je crois savoir de nous",
        description:
          "Exercice à deux : devinez ce que ressent votre partenaire sur 6 dimensions clés, puis comparez vos réponses.",
      },
      {
        key: "connais",
        path: "/connais",
        title: "Est-ce que je te connais vraiment ?",
        description:
          "Jeu de découverte guidé inspiré des travaux de Gottman pour stimuler la curiosité mutuelle et la complicité.",
      },
    ],
  },
  {
    id: "cahiers-exercices",
    title: "Cahiers & exercices",
    badge: "exercice",
    intro:
      "Supports d'exercices écrits, cahiers TCC et programmes structurés pour accompagner le travail entre les séances.",
    modules: [
      {
        key: "autogratification",
        path: "/autogratification",
        title: "Mon autogratification",
        description:
          "Un court rendez-vous quotidien (3 à 5 min) : ce qui a été difficile, ce qui a fonctionné, mes efforts, mes petites réussites, ce que je reconnais chez moi, puis une autogratification choisie. Bilan du jour, semaine positive avec courbe d'évolution, synthèse de séance à télécharger.",
      },
      {
        key: "sujets-therapeutiques",
        path: "/sujets-therapeutiques",
        title: "Mes sujets thérapeutiques",
        description:
          "Identifiez ce qui vous préoccupe, puis choisissez ce qui mérite votre attention en priorité : un parcours conversationnel, un sujet à la fois (importance × priorité), une cartographie des urgences thérapeutiques et une préparation de séance à télécharger.",
      },
      {
        key: "drivers-exo",
        path: "/drivers-exo",
        title: "Travail autour des drivers relationnels",
        description:
          "Cahier d'analyse des drivers : mises en situation, identification des antidotes et classement personnel.",
      },
      {
        key: "schemas-pensees",
        path: "/schemas-pensees",
        title: "Cahier de mes pensées automatiques",
        description:
          "Cahier TCC en 5 étapes : choisir les distorsions identifiées en séance, repérer leurs manifestations au quotidien, retrouver les situations personnelles et professionnelles où elles ont pesé, prendre du recul par les faits et les questions, puis choisir les actions à favoriser. PDF téléchargeable.",
      },
      {
        key: "programme-3-semaines",
        path: "/programme-3-semaines",
        title: "Programme 3 semaines",
        description:
          "Carnet de 3 semaines (5 minutes par jour) pour observer le quotidien, analyser ses habitudes et alléger la charge mentale.",
      },
    ],
  },
  {
    id: "enfant-famille",
    title: "Enfant & famille",
    badge: "famille",
    intro:
      "Outils ludiques à partager entre l'enfant et ses parents pour transformer le quotidien en terrain d'apprentissage de l'autonomie.",
    modules: [
      {
        key: "super-cerveau",
        path: "/super-cerveau",
        title: "Mission « Super-Cerveau »",
        description:
          "Jeu coopératif enfant-parent pour l'accompagnement du TDAH : rituel du soir en 5 étapes, XP, récompenses, défi Zéro rappel et conseil du dimanche.",
      },
      {
        key: "diva5",
        badge: "questionnaire",
        path: "/diva5",
        title: "DIVA-5 — préparation de l'entretien TDAH adulte",
        description:
          "Les 18 critères du DIVA-5 avec leurs exemples (âge adulte et enfance) à cocher par le patient et, séparément, par un proche. La cotation reste au praticien (grille incluse dans le PDF).",
      },
      {
        key: "conners3",
        badge: "questionnaire",
        path: "/conners3",
        title: "Conners 3 — échelle pour le parent",
        description:
          "Les 108 items et 2 questions ouvertes du Conners 3 parent (échelle 0–3), à remplir séparément par chaque parent, avec export PDF pour le praticien.",
      },
      {
        key: "assq",
        badge: "questionnaire",
        path: "/assq",
        title: "ASSQ — repérage TSA (parent)",
        publicHidden: true,
        description:
          "27 questions (Non / Un peu / Oui) à remplir par un parent ou un adulte qui connaît bien l'enfant, avec exemples et situations concrètes facultatives. Score total, 4 sous-échelles et synthèse calculés dans le navigateur : les réponses restent sur l'appareil du parent.",
      },
      {
        key: "tdah-parents",
        badge: "questionnaire",
        path: "/tdah-parents",
        title: "Évaluation parentale TDAH — perception croisée",
        prescription: true,
        description:
          "Questionnaire parental en 10 sections (regard parental, estime de soi, quotidien, émotions, crise, relations, école, expérience de parent, représentations, forces). Chaque parent répond seul via son lien personnel ; les réponses arrivent uniquement chez le professionnel, qui compare les perceptions. Aucun score ni conclusion n'est affiché aux parents.",
      },
      {
        key: "guide-tdah",
        badge: "guide",
        path: "/guide-tdah",
        title: "Guide pratique TDAH — parents & enseignants",
        description:
          "Comprendre le fonctionnement TDAH et accompagner l'enfant au quotidien : 16 chapitres courts et illustrés (école, maison, 7 exercices, phrases qui aident, fiches réflexes), PDF complet et fiches imprimables.",
      },
      {
        key: "boite-outils-tdah",
        badge: "guide",
        path: "/boite-outils-tdah",
        title: "Boîte à outils TDAH — préconisations scolaires",
        description:
          "20 fiches de préconisations centrées sur les solutions (attention, consignes, mémoire de travail, devoirs, évaluations, comportement…), à favoriser / à éviter, 10 règles d'or et formulation pour un compte rendu. Page web + PDF téléchargeable.",
      },
    ],
  },
];
